import React, { useState,useEffect } from "react";
import { Pagination,Spin } from 'antd';
import ResumeResultStats from "../resumeResultStats";
import ResumeResultsSearchSummary from "../resumeResultsSearchSummary";
import ResumeFilterSidebarForm from "../resumeFilterSidebarForm";
import ResumeResultsCardList from "../resumeResultsCardList";
import useRDBStore from "../../store/rdb";
import useSettingstore from "../../store/settings.store";
import "./resumeDbSearchResults.scss";
import { useSearchParams } from "react-router-dom";

function ResumeDbSearchResults() {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);  
  const { rdbPageResult, rdbResumeSearchPerPage } = useRDBStore();
  const { getSettingByKey } = useSettingstore();
  const rdbSearchValues = JSON.parse(getSettingByKey("resumeDB")?.value);
  const [searchParams, setSearchParams] = useSearchParams();
  const page = Math.max(1, Number(searchParams.get("page")) || 1);

  var currentItems = rdbPageResult?.foundresumes;
 
  var pendingRDBMetaData = JSON.parse(localStorage.getItem("pendingRDBMetaData"))==null?
                             []:JSON.parse(localStorage.getItem("pendingRDBMetaData"));  

  useEffect(() => {
       currentItems = rdbPageResult?.foundresumes;  
       ///console.log("UseEffect Params")
        setCurrentPage(page);     
  }, [rdbPageResult]);


  const handlePageChange = (newPage, pageSize) => {
      //console.log("Page:", newPage, pageSize, "PageSize:", pageSize);
      setCurrentPage(newPage);
      setPageSize(pageSize);
      setSearchParams((prev) => {
        if (newPage === 1) {
          prev.delete("page");
        } else {
          prev.set("page", String(newPage));
        }
        return prev;
      });      
      var encodejson = encodeJson(rdbSearchValues,newPage)
      //console.log("ResumeDbSearchResults encode json", encodejson, rdbSearchValues.duration)         
      rdbResumeSearchPerPage(encodejson,rdbSearchValues.duration);        
  };  
  
  const validValue = (value) => {
    if (value == undefined || value == null || value == "") {
      return false;
    }
    return true;
  };

  const encodeJson = (values,page) =>{

        let encodedJsonValues ={};

        //now fill the parameters
        encodedJsonValues.skills=rdbPageResult?.triggerreq.skills;
        encodedJsonValues.oskills=rdbPageResult?.triggerreq.oskills;
        encodedJsonValues.noticeperiod= rdbPageResult?.triggerreq?.noticeperiod !=''?parseInt(rdbPageResult?.triggerreq.noticeperiod):1024;
        encodedJsonValues.plocation=rdbPageResult?.triggerreq.preferredlocation;           
        encodedJsonValues.minexp= rdbPageResult?.triggerreq.minexp;
        encodedJsonValues.maxexp= rdbPageResult?.triggerreq.maxexp;
        encodedJsonValues.pagenum= page; //starts with first page
        encodedJsonValues.maxresumespp= pageSize;
        encodedJsonValues.duration = rdbPageResult?.triggerreq.duration

        encodedJsonValues.filter ={};
        encodedJsonValues.filter.minctc = rdbPageResult?.triggerreq.filter.minctc
        encodedJsonValues.filter.maxctc = rdbPageResult?.triggerreq.filter.maxctc
        encodedJsonValues.filter.clocation =rdbPageResult?.triggerreq.filter.cloaction
        
        const previousValues = JSON.parse(getSettingByKey("resumeDB").value);
        if(previousValues.filter !=undefined){
          
          encodedJsonValues.filter.workmode = previousValues.filter.workmode
          encodedJsonValues.filter.education= previousValues.filter.education

          encodedJsonValues.filter.candidatestatus = previousValues.filter.candidatestatus
          encodedJsonValues.filter.resumestatus = previousValues.filter.resumestatus
          encodedJsonValues.filter.interviewstatus = previousValues.filter.interviewstatus
          encodedJsonValues.filter.bgvstatus = previousValues.filter.bgvstatus
          encodedJsonValues.filter.offerstatus = previousValues.filter.offerstatus
          encodedJsonValues.filter.documentstatus = previousValues.filter.documentstatus
          encodedJsonValues.filter.lwdstatus=previousValues.filter.lwdstatus;
        }

        
        return encodedJsonValues
    }

  return (
     <div className="resumeDBSearchResults-wrapper">

      {
        rdbPageResult !=null?
        <>
          <div className="resumeDBSearchResults-Stats">
              <ResumeResultStats pageResult={rdbPageResult}/>
          </div>
          <div className="resumeDBSearchResults-summary-search">
              <ResumeResultsSearchSummary pageResult={rdbPageResult}/>
          </div>
          <div className="resumeDBSearchResults-filters">
              <ResumeFilterSidebarForm pageResult={rdbPageResult} page= {currentPage}  pageSize= {pageSize} pageHandler = {setCurrentPage}/>
          </div>
          <div className="resumeDBSearchResults-card-list">
              <ResumeResultsCardList pageResult={rdbPageResult} data={currentItems} 
                                     pendingRDBMetaData= {pendingRDBMetaData}
                                     page= {currentPage}
                                     pageSize= {pageSize}/>
          </div>

          <div className="resumeDBSearchResults-Pagination-list"  >
            <Pagination
              current={currentPage}
              pageSize={pageSize}
              total={rdbPageResult?.totalresumes}
              onChange={(page, pageSize) => {
                handlePageChange(page, pageSize);
              }}
              showSizeChanger
              pageSizeOptions={[10, 20, 50, 100, 150]}
              align="center" 
            />                                
          </div>    
        </>
        :<>
        </>
      }    
    </div>
  );
}

export default ResumeDbSearchResults;
